import React, { useState } from "react";
import Card from "components/card";
import AccessButton from "components/button/accessbutton";
import { CATEGORY_ICONS } from "variables/constants"
import { LuMessageSquare, LuPaperclip, LuSend } from "react-icons/lu";
import { Form } from "antd";
import FormItem from "components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";
import TextArea from "antd/es/input/TextArea";
import Button from "components/button";


const TicketDetailCard = ({ ticket }) => {
    const [form] = Form.useForm();
    const [message, setMessage] = useState("");
    if (!ticket) return null

    const {
        id,
        title,
        submittedBy,
        priority,
        status,
        category,
        description,
        replies,
    } = ticket;

    const Icon = CATEGORY_ICONS[ticket.category];

    const onSubmit = (formData) => {};
    

    return (
        <div className="space-y-6 max-w-[1400px] mx-auto">
            <AccessButton
                backLabel="Back to Tickets"
                withBack={true}
                baseRoute="/console/hr-support"
            />
            <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-xl border-2 border-pink-500 shadow-xl overflow-hidden">
                <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 
                                grid-cols-[1fr_auto] [.border-b]:pb-6 bg-gradient-to-br from-pink-50 to-rose-50 border-b"
                >
                    <div className="flex items-start justify-between">
                        <div className="flex items-start gap-3">
                            <div className="p-3 rounded-xl bg-gradient-to-br from-pink-500 to-rose-500 text-white shadow-md">
                                {Icon && (
                                    <Icon className="w-6 h-6" />
                                )}
                            </div>
                            <div>
                                <h4 className="text-[20px] mb-1">{title}</h4>
                                <p className="text-slate-700 text-[13px]">
                                    Ticket ID: {id} • Submitted by {submittedBy}
                                </p>
                                <div className="flex items-center gap-2 mt-2">
                                    <span className={`status-indicator uppercase font-semibold ${priority.toLowerCase().replace(/\s+/g, "-")}`}>
                                        {priority}
                                    </span>
                                    <span className={`status-indicator uppercase font-semibold ${status.toLowerCase().replace(/\s+/g, "-")}`}>
                                        {status}
                                    </span>
                                    <span className={`status-indicator text-[10px] ${category.toLowerCase().replace(/\s+/g, "-")}`}>
                                        {category}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pb-6 p-6">
                    <div className="space-y-6">
                        <div>
                            <h4 className="font-semibold text-[14px] mb-2">
                                Description
                            </h4>
                            <p className="text-[13px] text-slate-900">
                                {description}
                            </p>
                        </div>
                        <div className="bg-slate-200 shrink-0 h-px w-full"></div>
                        <div>
                            <h4 className="font-semibold text-[14px] mb-3">
                                Conversation ({replies})
                            </h4>
                            <div className="space-y-3">
                                <div className="bg-white text-slate-900 flex flex-col gap-6 rounded-xl border-2 border-slate-200 overflow-hidden">
                                    <div className="pb-6 p-4">
                                        <div className="flex items-start gap-3">
                                            <div className="p-2 rounded-lg bg-pink-100 text-pink-700">
                                                <LuMessageSquare className="w-4 h-4" />
                                            </div>
                                            <div className="flex-1">
                                                <div className="flex items-center justify-between mb-1">
                                                    <p className="font-semibold text-[13px]">
                                                        IT Support Team
                                                    </p>
                                                    <span className="text-[11px] text-slate-700">
                                                        1 hour ago
                                                    </span>
                                                </div>
                                                <p className="text-[11px] text-slate-700">
                                                    We've received your request and are currently investigating the issue. 
                                                    Can you please provide more details about when this started?
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-4">
                                <Form
                                    form={form}
                                    layout="vertical" 
                                    onFinish={onSubmit}
                                >
                                    <FormItem
                                        name="reply"
                                        rules={[requiredField()]}
                                    >
                                        <TextArea
                                            className="input-field"
                                            maxLength={255}
                                            placeholder="Type your response..."
                                            rows={2}
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                        />
                                    </FormItem>
                                </Form>
                                <div className="flex items-center justify-between">
                                    <Button
                                        className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all shrink-0 border bg-white text-slate-900 h-8 rounded-lg px-3 gap-2 hover:bg-slate-100 hover:text-slate-900 hover:shadow-none"
                                    >
                                        <LuPaperclip className="w-4 h-4" />
                                        Attach File
                                    </Button>
                                    <Button
                                        type="submit"
                                        className={`inline-flex items-center justify-center whitespace-nowrap rounded-lg text-sm font-medium transition-all shrink-0 h-9 px-4 py-2 gap-2 hover:shadow-none ${
                                            message.trim()
                                                ? "bg-gradient-to-r from-pink-600 to-rose-600 hover:from-pink-700 hover:to-rose-700 text-white"
                                                : "bg-gradient-to-r from-pink-600 to-rose-600 text-white opacity-50"
                                        }`}
                                    >
                                        <LuSend className="w-4 h-4" />
                                        Send Reply
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    );
}




export default TicketDetailCard;